import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-vue-next';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    style = _this$get.style;
  var k = this.config.k;
  return _$cv('div', _extends({
    'className': _$cn(this.getClassNames()),
    'style': this.getStyles ? this.getStyles(k) : style
  }, getRestProps(this)), children);
}
;